module.exports = __webpack_public_path__ + "img/personalization.4c418bb6.webp";